import React from 'react'

import { Title } from '../../../../../../packages/kiti/components/presentation/Text'

const Counter = ({ value }) => {
  return (
    <Title noMargin color="dark2">
      {value}
    </Title>
  )
}

export default Counter
